export default __webpack_public_path__ + "static/media/ReleaseNotes_LoadRequest_Disclaimer.870f61b1.png";